import React from 'react';
import { Player, Controls } from '@lottiefiles/react-lottie-player';
import GeniebookLogo from '@assets/illustration/auth/geniebook-logo';
import { useNavigate } from 'react-router-dom';

type AuthLayoutProps = {
  children?: React.ReactNode;
  illustration: string | object;
  className?: string;
  headerContainerClassName?: string;
  bodyContainerClassName?: string;
  animationContainerClassName?: string;
  formContainerClassName?: string;
  animationContent?: React.ReactNode;
};

const AuthLayout = ({
  children,
  illustration,
  className,
  headerContainerClassName,
  bodyContainerClassName,
  animationContainerClassName,
  formContainerClassName,
  animationContent,
}: AuthLayoutProps) => {
  const navigate = useNavigate();
  const toHome = () => {
    navigate('/');
  };
  return (
    <div
      className={
        'w-full h-fit' +
        (className !== undefined && className !== '' ? ' ' + className : '')
      }
    >
      <div
        className={
          'header-container fixed top-0 z-10 flex items-center w-full bg-white h-[64px] pl-[140px] max-lg:hidden' +
          (headerContainerClassName !== undefined &&
          headerContainerClassName !== ''
            ? ' ' + headerContainerClassName
            : '')
        }
      >
        <GeniebookLogo
          className="w-[150px] h-[24px] cursor-pointer"
          onClick={toHome}
        />
      </div>
      <div
        className={
          'body-container flex justify-center pl-24 pr-24 w-full max-lg:pl-[110px] max-lg:pr-[110px] max-sm:pl-[15px] max-sm:pr-[15px] h-[calc(100%-64px)] max-w-[1366px] m-auto' +
          (bodyContainerClassName !== undefined && bodyContainerClassName !== ''
            ? ' ' + bodyContainerClassName
            : '')
        }
      >
        <div
          className={
            'animation-container min-h-screen w-[65%] max-w-[675px] block max-lg:hidden items-stretch' +
            (animationContainerClassName !== undefined &&
            animationContainerClassName !== ''
              ? ' ' + animationContainerClassName
              : '')
          }
        >
          {animationContent !== undefined ? (
            animationContent
          ) : (
            <div className="flex-1 min-h-[700px]">
              <Player
                className="self-auto w-full max-w-[675px] min-w-[530px]"
                autoplay={true}
                src={illustration}
                loop={true}
              >
                <Controls visible={false} />
              </Player>
            </div>
          )}
        </div>
        <div
          className={
            'form-container flex justify-center items-center w-5/12 min-h-screen h-[710px] lg:z-0 max-lg:w-11/12 max-lg:flex max-lg:h-fit max-lg:max-w-[456px] max-lg:z-10 max-lg:relative' +
            (formContainerClassName !== undefined &&
            formContainerClassName !== ''
              ? ' ' + formContainerClassName
              : '')
          }
        >
          {children && children}
        </div>
        <div
          className={
            'auth-layout-background lg:hidden fixed w-[928px] h-[928px] rounded-full bg-primary-skyblue max-lg:z-0 object-left-bottom max-lg:bottom-[-35rem] max-lg:left-[-35rem] max-sm:bottom-[-40rem] max-sm:left-[-40rem]'
          }
        ></div>
      </div>
    </div>
  );
};

export default AuthLayout;
